import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Link, Divider, Typography } from '@mui/material';

import Logo from '../../components/logo';
import { boxStyleFormFooter } from './style';

const FormFooter = ({ show = false }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ ...boxStyleFormFooter, mt: show ? 4 : 2 }}>
      <Logo
        disabledLink
        alignSelf="center"
        sx={{
          width: show ? '25vh' : '20vh',
          height: show ? '15vh' : '10vh',
          mx: 'auto',
          display: 'block',
        }}
      />

      {/* Detailed privacy message */}
      {show && (
        <>
          <Typography variant="body2" paragraph sx={{ px: 3 }}>
            {t('pages.formPage.detailedPrivacyMessage')}
          </Typography>
          <Divider sx={{ my: 2 }} />
        </>
      )}

      <Typography variant="caption" sx={{ mt: show ? 2 : 1, display: 'block' }}>
        {t('pages.formPage.poweredBy')}
        <Link href="https://algorleap.com" target="_blank" rel="noopener noreferrer">
          Algor Leap Solutions
        </Link>
        . © 2023 - {new Date().getFullYear()} OryxOne Ticketing System.{' '}
        {t('pages.formPage.allRightsReserved')}
      </Typography>
    </Box>
  );
};

FormFooter.propTypes = {
  show: PropTypes.bool,
};

export default FormFooter;
